var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","clipped-left":true,"color":"indigo","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.setShowNavDrawer}}),_c('v-toolbar-title',[_vm._v("i-ean.")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }